import { Controller } from "@hotwired/stimulus"
export default class ActivityFilesController extends Controller {
  static targets = ["fileItem", "fileFieldTemplate", "fileFields"]

  addFileField() {
    let newFileField = this.fileFieldTemplateTarget.content.cloneNode(true)
    this.fileFieldsTarget.append(newFileField)
  }

  deleteFileListItem() {
    this.fileItemTarget.remove()
  }
}
